import { Check } from 'lucide-react';

export const ThankYou = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="bg-gradient-to-br from-cyan-50 to-white pt-12 px-4">
        <div className="flex justify-center mb-12">
          <h1 className="text-4xl md:text-5xl font-light text-black">Thank you!</h1>
        </div>

        <div className="max-w-md mx-auto">
          <div className="flex flex-col items-center bg-gradient-to-br from-cyan-300 to-cyan-600 text-white rounded-md p-8 mb-12">
            <div className="bg-white rounded-full p-4 mb-4">
              <Check className="w-12 h-12 text-cyan-500" strokeWidth={2.5} />
            </div>
            <h2 className="text-3xl font-light text-white mb-2">Feedback Submitted</h2>
            <p className="text-lg font-light text-center text-cyan-50">
              Your feedback has been successfully received. We appreciate you taking the time to
              help us improve!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
